import React from 'react'
import { useTranslation } from 'react-i18next';
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHashtag } from '@fortawesome/free-solid-svg-icons'
import TextCopyable from '../../common/TextCopyable.jsx';
import ButtonCircle from '../../common/buttons/ButtonCircle.jsx';
import TooltipSimple from '../../common/tooltips/TooltipSimple.jsx';
import { displayRequestRef } from '../../../../utils.js';
import { RequestHotel } from '../../../../interfaces/request-hotel.js';

interface Props {
	requestHotel: RequestHotel

	showHotel?: boolean,
	showHotelAddress?: boolean,
	showTitle?: boolean,
	showCheckinCheckout?: boolean,
	showConnectivityInfos?: boolean,
	showRequestId?: boolean,
	showRefClient?: boolean,
	showSource?: boolean,
	showFormRequest?: boolean,
	showCommission?: boolean,
	showSegmentation?: boolean,
	showFrameworkAgreement?: boolean,
	showAccommodation?: boolean,
	showVueClient?: boolean,
	showVueHotelier?: boolean,

	canManage?: boolean
	canDuplicate?: boolean // (societe?.central_desk != 1 && requests?.source != 'gc')
	canEditFrameworkAgreement?: boolean
}

export default function RequestsHotelsInfos({ 
	requestHotel,

	showHotel = true,
	showHotelAddress = false,
	showTitle = false,
	showConnectivityInfos = true,
	showRequestId = true,
	showRefClient = true,
	showSource = true,
	showFormRequest = true,
	showCommission = true,

	showFrameworkAgreement = true,
	showAccommodation = true,
	showVueClient = true,

	showCheckinCheckout = false, 
	showVueHotelier = false,
	showSegmentation = false,

	canDuplicate = false,
	canManage = true,
	canEditFrameworkAgreement = false

} : Props) {

	const { t: gctrad } = useTranslation();
	const has_central_booking_right = AUTH.membres_rights.includes('gps_central_booking_right');
	
	return (
		<Wrapper className="requests-hotels-infos text-gc-dark-blue">
			{showHotel && <TooltipSimple
				title={gctrad('Copier le nom de l établissement')}
			>
				<span 
					className="small font-weight-normal d-inline-block mr-3"
				>
					<TextCopyable
						icon={<i className="fa-regular fa-hotel mr-1"></i>}
						value={requestHotel?.hotel?.title}
						text={requestHotel?.hotel?.title?.truncate(50)}
					/>
				</span>

			</TooltipSimple>}

			{showHotelAddress && <TooltipSimple
				title={gctrad('Copier l adresse de l établissement')}
			>
				<span 
					className="small font-weight-normal d-inline-block mr-3"
				>
					<TextCopyable
						icon={<i className="fa-regular fa-location-dot  mr-1"></i>}
						value={requestHotel?.hotel?.address+' '+requestHotel?.hotel?.postalCode+' '+requestHotel?.hotel?.city}
						text={requestHotel?.hotel?.address+' '+requestHotel?.hotel?.postalCode+' '+requestHotel?.hotel?.city}
					/>
				</span>

			</TooltipSimple>}

			{showTitle && <TooltipSimple
				title={gctrad('Copier le nom de l évènement')}
			>
				<span 
					className="small font-weight-normal d-inline-block mr-3"
				>
					<TextCopyable
						icon={<i className="fa-regular fa-user-group mr-1"></i>}
						value={requestHotel?.title}
						text={requestHotel?.title}
					/>
				</span>

			</TooltipSimple>}


			{requestHotel.dateActivated &&
				<TooltipSimple
					title={gctrad('[:myspace] Date de la demande')}
				>
					<span
						className="small font-weight-normal d-inline-block mr-3"
					>
						<i className="fa-regular fa-calendar mr-1"></i>
						{requestHotel.dateActivated.formatDateTime({ year: 'numeric', month: 'numeric', day: 'numeric'})}
					</span>				
				</TooltipSimple>
			}

			{showCheckinCheckout && <TooltipSimple title={'requests_hotels_checkin_out'.trad()}>
				<span
					className="small font-weight-normal d-inline-block mr-3"
				>
					<i className="fa-regular fa-calendars mr-1"></i>
					{'du_au'.trad().replace('%1',(requestHotel.checkin?.formatDateTime({ year: 'numeric', month: 'numeric', day: 'numeric'}))).replace('%2',(requestHotel.checkout?.formatDateTime({ year: 'numeric', month: 'numeric', day: 'numeric'}))).ucFirst()}
				</span>
			</TooltipSimple>}
			
			{showConnectivityInfos && requestHotel?.connectivityInfos?.active && 
				<TooltipSimple
					title={gctrad('Copier la référence')+' '+requestHotel?.connectivityInfos.partners_name+' : '+requestHotel?.connectivityInfos.booking_ref}
				>
					<span className="small font-weight-normal d-inline-block mr-3" >
						<i className={"fak fa-"+requestHotel?.connectivityInfos.partners_code+" mr-1"}></i>
						<TextCopyable
							value={requestHotel?.connectivityInfos.booking_ref}
							text={requestHotel?.connectivityInfos.booking_ref}
						/>
					</span>
				</TooltipSimple>
			}

			{showRequestId && <TooltipSimple 
				title={gctrad('Copier la référence')}
			>
				<span 
					className="small font-weight-normal d-inline-block mr-3"
				>
					<TextCopyable
						icon={<FontAwesomeIcon icon={faHashtag} className="mr-1"/>}
						value={requestHotel?.request?.id}
						text={displayRequestRef(requestHotel?.request?.id)}
					/>
				</span>
			</TooltipSimple>}
			
			{showRefClient && requestHotel?.request?.refClient &&
				<TooltipSimple title={gctrad('Copier la référence client')}>
					<span 
						className="small font-weight-normal d-inline-block mr-3" 
						style={{lineHeight: '1rem'}}
					>
						<TextCopyable
							icon={<i className="fak fa-ref-client mr-1"></i>}
							value={requestHotel?.request?.refClient}
							text={requestHotel?.request?.refClient?.truncate(30)}
						/>
					</span>
				</TooltipSimple>
			}

			{showSource && !has_central_booking_right && requestHotel?.request?.source && 
				<TooltipSimple
					title={'source_dossier'.trad()}
				>
					<span 
						className={`small font-weight-normal d-inline-block mr-3 ${!['gc', 'web', 'direct', 'api'].includes(requestHotel?.request?.source) ? "text-danger" : ""}`}
						style={{lineHeight: '1rem'}}
					>
						<i className="fa-regular fa-crosshairs-simple mr-1"></i>
						{
							requestHotel?.request?.source == 'gc' ||
							requestHotel?.request?.source == 'web' ||
							requestHotel?.request?.source == 'direct' ||
							requestHotel?.request?.source == 'api' ?
								(requestHotel?.request?.source).trad()
							:
							requestHotel?.request?.source
						}
					</span>					
				</TooltipSimple>
			}

			{showFormRequest && 
				<TooltipSimple
					title={gctrad('Formulaire')}
				>
					<span 
						className="small font-weight-normal d-inline-block mr-3" 
						style={{lineHeight: '1rem'}}
					>
						<i className="fa-regular fa-memo-pad mr-1"></i>
						{requestHotel?.request?.formRequest?.name ?? gctrad('Formulaire par défaut')}
					</span>
				</TooltipSimple>
			}

			{showCommission && requestHotel.commissionStatus?.slug == 'commission_active' && <TooltipSimple
				title={gctrad('Commission d apporteur d affaires')}
			>
				<span 
					className="small font-weight-normal d-inline-block mr-3" 
					style={{lineHeight: '1rem'}}
				>
					<i className="mr-1 fa-regular fa-hand-holding-box" />
					{requestHotel.commissionRate} %
				</span>
			</TooltipSimple>}
		
			{showSegmentation &&
				<TooltipSimple
					title={gctrad('[:myspace] Segment')}
				>
					<span 
						className="small font-weight-normal d-inline-block mr-3" 
						style={{lineHeight: '1rem'}}
					>
						<i className="fa-light fa-chart-pie mr-1"></i>
						{
							requestHotel.request?.segmentation?.label ?? gctrad('[:rh_products] Aucun segment')
						}
					</span>					
				</TooltipSimple>
			}
			
			{showFrameworkAgreement && requestHotel.request?.frameworkAgreement?.id &&
				<TooltipSimple title={gctrad('Contrat cadre')}>
					{canEditFrameworkAgreement ?
						<a href="#" data-part="+" data-target={`providers//framework_agreements/view/${requestHotel.request?.frameworkAgreement?.id}`} className={`small font-weight-normal d-inline-block mr-3 get_part_link js-nav`} style={{lineHeight: '1rem'}}>
							<i className="fa-light fa-file-invoice mr-1"></i>
							{requestHotel.request?.frameworkAgreement?.title}
						</a>					
					:
						<span className={`small font-weight-normal d-inline-block mr-3 get_part_link js-nav`} style={{lineHeight: '1rem'}}>
							<i className="fa-light fa-file-invoice mr-1"></i>
							{requestHotel.request?.frameworkAgreement?.title}
						</span>					
					}
				</TooltipSimple>
			}
			
			{showAccommodation && !(requestHotel.request?.requestClassicData?.nbPaxTotal>0) &&
				<TooltipSimple
					title={gctrad('[:myspace] Le client n a pas demandé d hébergement')}
				>
					<span 
						className="small font-weight-normal d-inline-block mr-3" 
						style={{lineHeight: '1rem'}}
					>
						<i className="fa-regular fa-circle-exclamation mr-1"></i>
						{gctrad('[:request_site] Sans hébergement')}
					</span>						
				</TooltipSimple>	
			}

			{showVueClient && <TooltipSimple
				title={requestHotel.nbVueUser > 0 ? 'derniere_vu_client'.trad().replace('%1', requestHotel.vuUser.formatDateTime({ year: 'numeric', month: 'numeric', day: 'numeric'})) : 'aucune_vu_client'.trad()}
			>
				<span 
					className="small font-weight-normal d-inline-block mr-3"
					style={{lineHeight: '1rem'}}
				>
					<i className="fa-kit fa-eye-client"></i>
					{requestHotel.nbVueUser}
				</span>				
			</TooltipSimple>}
	
			{showVueHotelier && <TooltipSimple
				title={requestHotel.nbVueHotelier > 0 ? 'derniere_vu_hotelier'.trad().replace('%1', requestHotel.vuHotelier.formatDateTime({ year: 'numeric', month: 'numeric', day: 'numeric'})) : 'aucune_vu_hotelier'.trad()}
			>
				<span 
					className="small font-weight-normal d-inline-block mr-3"
					style={{lineHeight: '1rem'}}
				>
					<i className="fa-kit fa-eye-hotelier"></i>
					{requestHotel.nbVueHotelier}
				</span>				
			</TooltipSimple>}


			{canManage && <span className="d-inline-block mr-3">
				<ButtonCircle 
					href={'providers//requests_hotels/manage_infos/' + requestHotel.id}
					part='+'
					icon={<i className="fa-regular fa-pen-to-square"></i>}
					tooltip={true}
					tooltipText={gctrad('[:myspace] Gérer la demande')}
				/>
			</span>}

			{canDuplicate && <span className="d-inline-block mr-3">
					<ButtonCircle 
						href={'providers//requests_hotels/duplicate_request/' + requestHotel.id}
						part='+'
						icon={<i className="fa-regular fa-copy"></i>}
						tooltip={true}
						tooltipText={gctrad('[:gps] Dupliquer la demande')}
					/>
				</span>
			}

		</Wrapper>
	);
}

const Wrapper = styled.div`
	.requests-hotels-infos {
		i {
			font-size: 1rem;
		}

		.h6 {
			line-height: .5rem;
		}

		.small {
			font-size: 80%;
		}
	}
`